module.exports = __webpack_public_path__ + "static/media/fvs_salaMendoza_17.2a7cd908.jpg";